import classes from "./styles/mainLayout.module.css";
import Footer from "../components/layout/Footer";
import { Outlet } from "react-router-dom";
import SearchNavbarCircular from "../components/layout/SearchNavbarCircular";


const CircularSearchLayout = () => {
  return (
    <>
      <header><SearchNavbarCircular/></header>
      <div className={classes.main}><Outlet /></div>
      <footer><Footer/></footer>
    </>
  );
};

export default CircularSearchLayout;
